import React from 'react';

interface StatusMessageProps {
  type: 'loading' | 'error';
  message?: string;
  className?: string;
}

const StatusMessage: React.FC<StatusMessageProps> = ({ type, message, className = '' }) => {
  if (type === 'loading') {
    return (
      <div className={`rounded-[1.5rem] border border-[color:var(--wf-border)] bg-[linear-gradient(180deg,rgba(251,246,238,0.96),rgba(246,239,229,0.94))] px-6 py-5 shadow-[0_18px_50px_rgba(44,32,27,0.08)] ${className}`}>
        <div className="flex items-center justify-center gap-3 text-[color:var(--wf-plum)]">
          <div className="h-8 w-8 animate-spin rounded-full border-2 border-[color:var(--wf-brass)]/25 border-t-[color:var(--wf-plum)]"></div>
          <span className="text-sm uppercase tracking-[0.2em] text-[color:var(--wf-brass)]">Loading</span>
        </div>
      </div>
    );
  }

  return (
    <div className={`rounded-[1.5rem] border border-red-200 bg-red-50/90 p-5 shadow-[0_18px_50px_rgba(44,32,27,0.08)] ${className}`}>
      <p className="text-red-700">{message || 'An error occurred'}</p>
    </div>
  );
};

export default StatusMessage;
